import { combineReducers } from 'redux'
import * as actionTypes from './actionTypes'

export const isSubmittingReducer = (state = false, action) => {
	switch (action.type) {
		case actionTypes.REGISTER_FOR_ACTIVITY_PACK_REQUEST:
			return true

		case actionTypes.REGISTER_FOR_ACTIVITY_PACK_SUCCESS:
		case actionTypes.REGISTER_FOR_ACTIVITY_PACK_ERROR:
			return false

		default:
			return state
	}
}

export const errorReducer = (state = null, action) => {
	switch (action.type) {
		case actionTypes.REGISTER_FOR_ACTIVITY_PACK_REQUEST:
		case actionTypes.REGISTER_FOR_ACTIVITY_PACK_SUCCESS:
			return null

		case actionTypes.REGISTER_FOR_ACTIVITY_PACK_ERROR:
			return action.error

		default:
			return state
	}
}

export default combineReducers({
	submitting: isSubmittingReducer,
	error: errorReducer,
})

export const getRequestingActivityPackStatus = state => state.submitting
export const getRequestActivityPackError = state => state.error
